import { newsDetail,newsList,newsMainList } from '@/api/news'

const state = {
  newsId:'', // 新闻id
  newsList:[] // 新闻列表
}

const mutations = {
  NEWSLIST(state, newsList){
    state.newsList = newsList
  }
}

const actions = {
  findNewsD ({ commit }, data) {
    // console.log(data)
    return new Promise((resolve, reject) => {
      newsDetail(data).then((res) => {
        // console.log(resolve(res))
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findNewsL ({ commit }) {
    return new Promise((resolve, reject) => {
      newsList().then((res) => {
        // console.log(resolve(res))
        return resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findMainList({ commit }) {
    // console.log(data)
    return new Promise((resolve, reject) => {
      newsMainList().then((res) => {
        commit('NEWSLIST', res)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
